class CustomContactForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.submitButton = this.form?.querySelector('button[type="submit"]');
    this.spinner = this.submitButton?.querySelector(".loading-overlay__spinner");
    this.fileUpload = this.querySelectorAll("input[type=file]");
    this._isLoading = false;
    this.successMsg = this.querySelector(".js-form-success");
    this.errorMsg = this.querySelector(".js-form-error");
  }

  get isLoading() {
    return this._isLoading;
  }

  set isLoading(value) {
    if (this._isLoading === value) return;
    this._isLoading = value;
    this.onLoadingChange(value);
  }

  toggleMessages(type) {
    if (type === "success") {
      this.successMsg?.classList.remove("hidden");
      this.errorMsg?.classList.add("hidden");
    } else {
      this.successMsg?.classList.add("hidden");
      this.errorMsg?.classList.remove("hidden");
    }
  }

  onLoadingChange(isLoading) {
    if (isLoading) {
      this.classList.add("loading");
      this.submitButton?.classList.add("loading");
      this.spinner?.classList.remove("hidden");
      this.submitButton?.setAttribute("disabled", "true");
    } else {
      this.classList.remove("loading");
      this.spinner?.classList.add("hidden");
      this.submitButton?.classList.remove("loading");
      this.submitButton?.removeAttribute("disabled");
    }
  }

  connectedCallback() {
    if (this.form) {
      this.form.addEventListener("submit", this.#onSubmit.bind(this));
    }

    if (this.fileUpload) {
      this.fileUpload.forEach((input) => {
        input.addEventListener("change", (event) => {
          this.filesArray = this.filesArray || [];
          const inputElement = /** @type {HTMLInputElement} */ (event.target);
          if (!inputElement?.files) return;

          Array.from(inputElement.files).forEach((file) => {
            this.filesArray.push(file);
            this.#addUploadedFile(file);
          });
        });
      });
    }
  }

  /**
   * @param {SubmitEvent} event
   */
  #onSubmit(event) {
    event.preventDefault();
    console.log("Form submitted");
    const formData = this.#createFormData(event);

    this.isLoading = true;
    fetch("/apps/sanatura-app/influencer-form", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(`Form submission failed with status ${response.status}`);
        }
        this.form?.classList?.add("success");
        this.toggleMessages("success");
      })
      .catch((err) => {
        console.error("Form submission error:", err);
        this.toggleMessages("error");
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  /**
   * @param {SubmitEvent} event
   */
  #createFormData(event) {
    // @ts-ignore
    const formData = new FormData(event.target);

    /** @type {Record<string, any>} */
    const data = {};

    for (let [key, value] of formData.entries()) {
      // Match keys like contact[name]
      const match = key.match(/^(\w+)\[(\w+)\]$/);

      if (match) {
        const objName = match[1]; // "contact"
        const propName = match[2]; // "name", "email", "body"

        if (!objName || !propName) continue;

        if (!data[objName]) data[objName] = {};
        data[objName][propName] = value;

        continue;
      }

      // plain fields without brackets
      data[key] = value;
    }

    const finalFormData = new FormData();
    const body = {};

    for (const [key, value] of Object.entries(data)) {
      if (!key.includes("contact") && !key.includes("nodemailer")) {
        body[key] = value;
      }
    }

    Object.assign(body, {
      ...data.nodemailer,
      ...data.contact,
    });

    finalFormData.append("requestBody", JSON.stringify(body));

    // Add files to FormData
    if (this.filesArray) {
      Array.from(this.filesArray).forEach((file) => {
        const fileBlob = new Blob([file], { type: file.type });
        finalFormData.append("files[]", fileBlob, file.name);
      });
    }

    return finalFormData;
  }

  /**
   * Adds an uploaded file to the uploaded files list.
   * @param {File} file
   */
  #addUploadedFile(file) {
    /** @type {HTMLElement | null} */
    const parent = this.querySelector(".uploaded-files");
    if (parent) {
      /** @type {HTMLParagraphElement} */
      const p = document.createElement("p");
      p.textContent = file.name;
      parent.appendChild(p);
    }
  }
}

if (!customElements.get("custom-contact-form")) customElements.define("custom-contact-form", CustomContactForm);
